var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1867 28.4378L20.2463 21.1965C19.8313 19.6474 20.7538 18.0496 22.3028 17.6346L29.5442 15.6943C31.0932 15.2792 32.0157 13.6814 31.6007 12.1323C31.1856 10.5832 29.5878 9.66072 28.0387 10.0758L20.7974 12.0161C19.2484 12.4312 17.6505 11.5087 17.2355 9.95961L15.2951 2.71831C14.8801 1.16924 13.2823 0.246732 11.7332 0.661805C10.1841 1.07688 9.26161 2.67469 9.67668 4.22377L11.617 11.4651C12.0321 13.0141 11.1096 14.612 9.56049 15.027L2.31918 16.9673C0.770107 17.3824 -0.152393 18.9802 0.26268 20.5293C0.677753 22.0784 2.27558 23.0009 3.82465 22.5858L11.066 20.6455C12.615 20.2304 14.2129 21.1529 14.6279 22.702L16.5682 29.9433C16.9833 31.4924 18.5811 32.4149 20.1302 31.9998C21.6792 31.5847 22.6017 29.9869 22.1867 28.4378Z",
    fill: "#FFDC60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.c3b8316ee9b06f9ad4ed2a80eb643bd7.svg";
export { ForwardRef as ReactComponent };